import React, { useEffect } from 'react';
import { PayInFullContent } from 'src/components/popup-learn-more-pay-in-full/components/pay-in-full-content';
import { LearnMoreContainer } from 'src/components/v2/learn-more-container';
import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { useAppContext } from 'src/context/store/app-provider';
import { useAnalytics } from 'src/hooks/use-analytics';
import { SegmentEventType } from 'src/types/segment';

import { Dialog } from '../dialog';

interface Props {
  isShow: boolean;
  onClose: () => void;
  onCloseAfter?: () => void;
}

export const PopupLearnMorePayInFull = ({
  isShow,
  onClose,
  onCloseAfter,
}: Props) => {
  const logAnalyticEvent = useAnalytics();
  const { currency, installmentsCount, publicKey, selector } = useAppContext();

  useEffect(() => {
    if (isShow) {
      logAnalyticEvent({
        event: SegmentEventType.LEARN_MORE_POP_UP_OPENED,
        publicKey: publicKey ? 'yes' : 'no',
        merchantIntegrationType: selector ? 'snippetAndPopup' : 'popupOnly',
        planSelected: installmentsCount,
        popupType: 'standardWithInfo',
        merchantCountry: COUNTRY_NAME_BY_CURRENCY_MAP[currency],
        integrationType: selector ? 'native' : 'custom',
      });
    }
  }, [
    isShow,
    currency,
    installmentsCount,
    logAnalyticEvent,
    publicKey,
    selector,
  ]);

  const close = (action: 'cross' | 'inactive zone' | 'continue') => {
    logAnalyticEvent({
      event: SegmentEventType.LEARN_MORE_POP_UP_CLOSED,
      publicKey: publicKey ? 'yes' : 'no',
      merchantIntegrationType: selector ? 'snippetAndPopup' : 'snippetAndPopup',
      planSelected: installmentsCount,
      popupType: 'standardWithInfo',
      merchantCountry: COUNTRY_NAME_BY_CURRENCY_MAP[currency],
      action,
    });
    onClose();
  };

  return (
    <Dialog
      isShow={isShow}
      onClose={() => close('inactive zone')}
      onCloseAfter={onCloseAfter}
    >
      <LearnMoreContainer>
        <PayInFullContent
          onClose={() => close('cross')}
          onContinue={() => close('continue')}
        />
      </LearnMoreContainer>
    </Dialog>
  );
};
